module.exports = __webpack_public_path__ + "assets/img/people.18d3843a.png";